/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateMarketMakerOptions,
  UpdateMarketMakerResponses,
} from '../types/UpdateMarketMaker'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Replace MM configuration and assigned order books atomically
 * {@link /v1/market-makers}
 */
export function updateMarketMaker<ThrowOnError extends boolean = true>(
  options: Options<UpdateMarketMakerOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateMarketMakerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/market-makers',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateMarketMakerResponses, ThrowOnError>>,
  )
}
